module.exports = __webpack_public_path__ + "img/Skirt-Back-B4-Da-Fb-Gb-Hc-Ia-Gd.9910ce41.png";